import { render } from "./MenuDynamic.vue?vue&type=template&id=8ac424a0&scoped=true"
import script from "./MenuDynamic.vue?vue&type=script&lang=js"
export * from "./MenuDynamic.vue?vue&type=script&lang=js"

import "./MenuDynamic.vue?vue&type=style&index=0&id=8ac424a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac424a0"]])

export default __exports__